import { string, object, number } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  return object({
    [`${formatName(properties['label']?.$id as string)}`]:
      string().required('Required'),
    [`${formatName(properties['id']?.$id as string)}`]: string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(properties['styling']?.$id as string)}`]:
      string().required('Required'),
    [`${formatName(properties['gridSize']?.$id as string)}`]: number()
  });
};
